import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { saveAs } from 'file-saver';
import { ScrollArea } from '../../../components/';
import { LinkText } from '../../../components';
export const LicenseListCard = (props) => {
    const { qualifications } = props;
    const { t } = useTranslation();
    const onDownloadQualifications = (url) => {
        saveAs(url);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(STitle, null, t('所有資格一覧')),
        React.createElement(ScrollArea, { height: "300px" }, qualifications.map((obj) => {
            var _a, _b;
            return (React.createElement(SLinkWrapper, { key: obj.url },
                React.createElement(LinkText, { onClick: () => onDownloadQualifications(obj.url) }, (_b = (_a = obj) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.text)));
        }))));
};
const STitle = styled.p `
  font-weight: bold;
  font-size: 18px;
`;
const SLinkWrapper = styled.div `
  padding-left: 24px;
  padding-bottom: 16px;
`;
